import { render } from "./NewResidentModal.vue?vue&type=template&id=9999ea16"
import script from "./NewResidentModal.vue?vue&type=script&lang=js"
export * from "./NewResidentModal.vue?vue&type=script&lang=js"

import "./NewResidentModal.vue?vue&type=style&index=0&id=9999ea16&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__